export default class AddMachineModelDocumentsRequest {

    public productId: string | null = null;

    public ProductInfoId: string | null = null;

    public fileReference: string | null = null;
    
    public fileName: string | null = null;
}